import { atom } from 'jotai'

export const loadOneTrustAtom = atom(false)
